<template>
    <div class="acountStatus"> 
        <div>
            <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
            <message-component :message="response_msg" :messageType="msg_type"></message-component>
        </div>
        <div class="mainTitle d-flex justify-content-between align-items-center">
            <h2 class="mb-3">{{$t('dt_depTransHist')}}</h2>
			<div class="">
                <router-link :to="'/account-funding'" class="common_btn btn_xs mr-2">{{$t('fxBack')}}</router-link>
            </div>
        </div>
        <div class="timeLineHistory py-0 px-3 row no-gutters justify-content-center mt-3 " v-if="(!pageLoader && trans_hitory != '' && trans_hitory.length > 0)">
            <div class="col-md-12 whiteBG p-3 mb-3  position-relative" v-for="list in trans_hitory">
                <div class="historyDeposit d-flex justify-content-between align-items-center " :class="(parseInt(list.status) == 1)?'complete':''">
                    <div class="d-flex mr-4">
                    <div class="d-flex align-items-center justify-content-center blockID mr-4">
                        <p class="mb-0 text-center momentDate"><span class="DateArea">{{list.created | moment("DD")}}</span> <span class="dateinfo">{{list.created | moment("MMM YYYY")}}</span></p>
                    </div>
                    <div class="d-flex align-items-center blockID">
                        <figure class="historyList-icon mr-3">
                            <img :src="'../../../../static/fxView/images/'+$env_var.currencyImages[list.currency.toUpperCase()]" class="data_currency rounded-circle">
                        </figure>
                        <div class="blockID">
                            <p class="tI mb-0">{{$t('dep_acc_fund_accountId')}}</p>
                            <h5 class="tL mb-0">{{list.trading_account_id}}</h5>
                        </div>
                    </div>
                    </div>
                    <div class="blockID transIdN">
                        <p class="tI mb-0">{{ $t('fxDepositAmount') }}</p>
                        <h2 class="priceID green  mb-0">{{$env_var.currencyIcon[list.currency]}} {{list.amount}}</h2>
                    </div>
                    
                    <div class="blockID transIdN">
                        <p class="tI mb-0">{{$t('dl_transId')}}</p>
                        <h5 class="tL mb-0">{{list.transactionId}} </h5>
                    </div>
                    <div class="blockID transIdN">
                        <p class="tI mb-0">{{$t('dt_payMeth')}}</p>
                        <h5 class="tL mb-0">{{$env_var.depositMethod[list.method]}}</h5>
                    </div>
                        
                    <div class="blockID  transIdButton d-flex align-items-center justify-content-end"> 
                        <div class="d-flex"> 
                            <p class="alert mb-0 text-center" :class="badgeColor[list.status]">{{$env_var.paymentStatus[list.status]}}</p>
                            <router-link :to="{name: 'fxView.support', params: {tabName:'openRequest'}}"   title="View" data-placement="top" class="bdMore btn_xs grd_btn d-flex align-items-center"  data-toggle="tooltip" v-if="parseInt(list.status) == 4">
                                <feather type="eye"></feather> {{$t('dt_clickToResolve')}}
                            </router-link>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    export default {
        name: 'DEPOSIT-TRANSACTION',
        mixins: [fxViewMixins],
        data() {
            return {
                //===========prop in loader component=======
                col_span : 8,
				        trans_hitory : [],
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,

                //==========================================
                pageLimit : '15',
                search : '',
                page : '1', 
                badgeColor: {"-1":"alert-info", "0": "alert-warning", "1": "alert-success", "2":"alert-danger", "3":"alert-danger", "4": "alert-danger"}
            }
        },
        methods:{
            listing(){
                let inputJson = {
                    'globalParams' : {
                        transaction_id  :  this.$route.query.id
                    } ,'localParams' : {'parameter' : this}
                }
                this._runGetTransactionStatus(inputJson)
            }
        },
        created(){
            this.listing()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/deposit/deposit_transaction.vue